import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/merchants`;

export default {
  getMerchantMessages(merchantId, baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}/${merchantId}/messages`, {
      baseURL,
      headers,
      params,
    });
  },
  readMessage(merchantId, baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.post(
      `${resource}/${merchantId}/messages/read`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
};
